export const devOpsDefaultUrl='https://access2.visualstudio.com/AccessWeb/_workitems/edit/'